import { setDefaults, getRenderElement } from '@udecode/slate-plugins';
import divElement from './element';

const renderDiv = options => {
  const { div } = setDefaults(options, divElement);

  return getRenderElement(div);
};

export default renderDiv;
